import React from 'react';
import {FilterDispatcherContext} from "@providers/filters";
import Selection from "@molecules/selection/selection";
import {UpdateSelectionOptions} from "@hooks/selection.options";

export default function DensityFilter(props) {
    const filterDispatcher = React.useContext(FilterDispatcherContext);

    const {show, options, selected_items} = props.items;
    const selectedItemsCopy = [...selected_items];

    function handleChange(data) {
        if (JSON.stringify(data.items) !== JSON.stringify(selectedItemsCopy)) {
            const new_option = UpdateSelectionOptions(options, data);
            filterDispatcher({
                type: 'DENSITY_OPTIONS',
                payload: new_option
            })
        }
    }

    return (
        <div className={(show ? 'd-block' : 'd-none') + ' ' + (typeof props.className !== "undefined" ? props.className : '')}>
            <Selection
                type="multiple"
                name={props.name ?? "density"}
                options={options}
                selected_items={selected_items}
                label="تراکم"
                onChange={(data) => handleChange(data)}
                caption_show={props.caption_show ?? undefined}
                showLabelAndSelected={!!(props.showLabelAndSelected)}
            />
        </div>
    )
}